import { Stack, Avatar, Typography } from "@mui/material";
import BoxHeader from "../../components/atoms/BoxHeader";
import TabsComponent from "../../components/atoms/Tabs";
import { useEffect, useState, useContext } from "react";
import Servicios from "../../components/molecules/Servicios";
import Agentes from "../../components/molecules/Agentes";
import Navbar from "../../components/organisms/Navbar";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";
import useWexClient from "../../hooks/Clients/wexClient,";
import stylesDashboard from "../../styles/Organisms/OpcionDashboard/dasboard";
import ReportesTab from "./components/ReportesTab";
import { AuthContext } from "../../Auth/Context";

function OptionService() {
  const { payload, payloadMaster } = useContext(AuthContext);
  const { t } = useTranslation();
  const [value, setValue] = useState("1");
  const [tabs, setTabs] = useState([
    {
      label: t("Welcome.text105"),
      key: "1",
    },
    {
      label: t("Welcome.text106"),
      key: "2",
    },
    {
      label: t("Welcome.text69"),
      key: "3",
    },
  ]);

  const { getServices } = useWexClient();
  const [service, setService] = useState([]);
  const [image, setImage] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");

  useEffect(() => {
    const fetchDataFromAPI = async () => {
      try {
        const apiData = await getServices(payload._id);

        const serviceData = apiData.map((item) => ({
          id: item._id,
          name: item.name,
        }));

        const imageData = apiData.map((item) => item._config.avatarClient);

        setService(serviceData);
        setImage(imageData);

        const initialOption = serviceData.length > 0 ? serviceData[0].id : "";
        setSelectedOption(initialOption);
        sessionStorage.setItem("SelectedOption", initialOption);
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataFromAPI();
  }, [payload._id]);

  const selectedPosition = service.findIndex(
    (option) => option.id === selectedOption,
  );

  const selectedImage = selectedPosition !== -1 ? image[selectedPosition] : "";

  // Obtener el nombre del servicio seleccionado
  const selectedService = service.find(
    (option) => option.id === selectedOption,
  );
  const serviceName = selectedService ? selectedService.name : "Cargando...";

  return (
    <Stack
      sx={{
        width: "100vw",
        height: "100vh",
      }}
    >
      <Stack sx={{ width: "100%" }}>
        <Navbar />
      </Stack>
      <Stack
        style={{
          background: "linear-gradient(45deg, #fe6298, #ff8766)",
          width: "100vw",
        }}
      >
        <BoxHeader>
          <Stack
            direction="column" // Añadido para mantener la misma estructura que OpcionDashboard
            sx={{
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "22.3rem",
            }}
          >
            <Stack
              direction="row"
              style={{
                ...stylesDashboard.div,
                marginTop: "1rem",
              }}
            >
              <Stack>
                <div
                  style={{
                    ...stylesDashboard.divb,
                    width: "8rem",
                    height: "8rem",
                    borderRadius: "35rem",
                  }}
                >
                  {selectedImage !== null ? (
                    <Avatar
                      src={selectedImage}
                      sx={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  ) : (
                    console.log("No se ha encontrado una imagen")
                  )}
                </div>
              </Stack>
              <Stack
                sx={{
                  ...stylesDashboard.title,
                  marginLeft: "1rem",
                  marginTop: "10rem",
                }}
              >
                <Typography variant="h4">{serviceName}</Typography>
              </Stack>
            </Stack>
            <Stack
              sx={{
                marginBottom: "1rem",
                width: "60%",
              }}
            >
              <TabsComponent
                value={value}
                setValue={setValue}
                tabs={tabs}
                selectedBackgroundColor="#c3468a"
              />
            </Stack>
          </Stack>
        </BoxHeader>
      </Stack>
      <Stack
        sx={{
          width: "100vw",
          alignItems: "center",
          height: value === "1" ? "120%" : "120%",
          backgroundColor: "white",
        }}
      >
        <Stack sx={{ width: "60%", marginTop: "3rem" }}>
          {value === "1" && <Agentes />}

          {value === "2" && <Servicios />}

          {value === "3" && <ReportesTab />}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default OptionService;
